// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1foaG","choiceBoxes":"toolbarselects_choiceBoxes__3Qeqx","simpleField":"toolbarselects_simpleField__2nX3f"};